export const streamers = [
  {
    id: "s1",
    name: "峡谷之巅·阿凯",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20confident%20young%20male%20esports%20streamer%20wearing%20a%20gaming%20headset%2C%20clean%20soft%20blue%20studio%20background%2C%20modern%20friendly%20lighting%2C%20high%20detail&width=400&height=400&seq=avatar-s1&orientation=squarish",
    channel: "game",
    level: "签约主播",
    bio: "前职业选手，擅长打野运营与节奏带动，每晚 20:00 准时开播冲王者。",
    followers: "182.6 万",
    socials: [
      { icon: "ri-wechat-line", label: "微信" },
      { icon: "ri-weibo-line", label: "微博" },
    ],
  },
  {
    id: "s2",
    name: "甜心小鹿",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20cheerful%20young%20female%20live%20streamer%20with%20a%20bright%20smile%2C%20clean%20soft%20warm%20studio%20background%2C%20modern%20friendly%20lighting%2C%20high%20detail&width=400&height=400&seq=avatar-s2&orientation=squarish",
    channel: "entertainment",
    level: "人气主播",
    bio: "脱口秀与情感话题担当，擅长把日常小事讲成段子，连麦互动从不冷场。",
    followers: "246.3 万",
    socials: [
      { icon: "ri-weibo-line", label: "微博" },
      { icon: "ri-tiktok-line", label: "抖音" },
    ],
  },
  {
    id: "s3",
    name: "名师 Emily",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20professional%20female%20english%20teacher%20with%20glasses%2C%20clean%20soft%20neutral%20studio%20background%2C%20modern%20friendly%20lighting%2C%20high%20detail&width=400&height=400&seq=avatar-s3&orientation=squarish",
    channel: "education",
    level: "金牌讲师",
    bio: "雅思口语与商务英语讲师，十年一线教学经验，课堂节奏轻松又高效。",
    followers: "96.8 万",
    socials: [
      { icon: "ri-wechat-line", label: "微信" },
      { icon: "ri-book-2-line", label: "专栏" },
    ],
  },
  {
    id: "s4",
    name: "星河不夜",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20an%20artistic%20young%20male%20singer%20holding%20a%20microphone%2C%20clean%20soft%20indigo%20studio%20background%2C%20modern%20friendly%20lighting%2C%20high%20detail&width=400&height=400&seq=avatar-s4&orientation=squarish",
    channel: "music",
    level: "签约主播",
    bio: "古风与流行翻唱都拿手，深夜点歌专场，用声音陪你度过每一个加班的夜晚。",
    followers: "134.1 万",
    socials: [
      { icon: "ri-music-2-line", label: "作品" },
      { icon: "ri-weibo-line", label: "微博" },
    ],
  },
  {
    id: "s5",
    name: "篮球评论员大鹏",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20an%20energetic%20male%20sports%20commentator%20wearing%20a%20headset%2C%20clean%20soft%20neutral%20studio%20background%2C%20modern%20friendly%20lighting%2C%20high%20detail&width=400&height=400&seq=avatar-s5&orientation=squarish",
    channel: "sports",
    level: "特邀解说",
    bio: "十五年篮球解说经验，赛前深度分析、赛后即时复盘，观点犀利又接地气。",
    followers: "88.5 万",
    socials: [
      { icon: "ri-basketball-line", label: "赛事" },
      { icon: "ri-weibo-line", label: "微博" },
    ],
  },
  {
    id: "s6",
    name: "林师傅",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20friendly%20middle%20aged%20male%20chef%20in%20an%20apron%2C%20clean%20soft%20warm%20studio%20background%2C%20modern%20friendly%20lighting%2C%20high%20detail&width=400&height=400&seq=avatar-s6&orientation=squarish",
    channel: "life",
    level: "人气主播",
    bio: "二十年灶台功力，家常菜与深夜食堂系列都拿手，边做边聊，烟火气十足。",
    followers: "112.7 万",
    socials: [
      { icon: "ri-restaurant-2-line", label: "菜谱" },
      { icon: "ri-weibo-line", label: "微博" },
    ],
  },
];